module.exports = __webpack_public_path__ + "static/icons/icon-recent-forecast-c05b73d7d4efe4d6c352bef1dfadfb71.svg";